import { render, staticRenderFns } from "./updateMealPlan.vue?vue&type=template&id=5f290ffa&"
import script from "./updateMealPlan.vue?vue&type=script&lang=js&"
export * from "./updateMealPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports